// BEGIN - global.js
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  if (elementToFocus){
    elementToFocus.focus();
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.boundOnButtonClick = this.onButtonClick.bind(this);
  }

  connectedCallback() {
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.boundOnButtonClick)
    );
  }

  disconnectedCallback() {
    this.querySelectorAll("button").forEach((button) =>
      button.removeEventListener("click", this.boundOnButtonClick)
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    /* this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);*/
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    this.sliderLastItem =
      this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - step * this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      // this.updateMedia()
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.setAvailable();
      //this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    //include Product Slider
    productSliderupdate(this.currentVariant.featured_media.id);

    /*const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

   const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);*/
  }
  updateURL() {
    var isHairstyling = document.getElementsByClassName("hairstyling-guide");
    var wHistory = 0;
    if (isHairstyling.length > 0) {
      wHistory = 1;
    }

    if (wHistory == 0) {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      let show_autodeliver = 0;
      if (jQuery(".rc_radio__autodeliver").length > 0) {
        if (jQuery(".rc_radio__autodeliver").is(":checked")) {
          show_autodeliver = 1;
        }
      }

      if (show_autodeliver > 0) {
        let var_id = this.currentVariant.id;
        let dataset_section = this.dataset.section;
        jQuery(
          `#product-form-${this.dataset.section} #rc_duplicate_selector option`
        ).each(function (i) {
          let from = jQuery(this).data("from");
          if (from == var_id) {
            jQuery(
              `#product-form-${dataset_section} #curentvariant_autodeliver`
            ).val(jQuery(this).val());
          }
        });
      } else {
        input.value = this.currentVariant.id;
      }
      //   input.dispatchEvent(new Event("change", { bubbles: true }))
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    //if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const destination_variation = document.getElementById(
          `Option-${this.dataset.section}-1`
        );
        const source_variation = html.getElementById(
          `Option-${this.dataset.section}-1`
        );
        if (source_variation && destination_variation)
          destination_variation.innerHTML = source_variation.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );

        const productForms = document.querySelector(
          `#product-form-${this.dataset.section}`
        );
        let productid = productForms.getAttribute("data-productid");

        let toid = 0;
        let curr_price = 0;
        let curr_price_subs = 0;
        let curr_price_val = 0;
        let curr_price_subs_val = 0;
        let currentVariant = this.currentVariant.id;
        let subs_Product_d = subs_Product[productid];
        jQuery.each(subs_Product_d.variant_to_duplicate, function (key, val) {
          if (key == currentVariant) {
            toid = val;
          }
        });
        jQuery.each(subs_Product_d.duplicate_to_price, function (key, val) {
          if (key == toid) {
            curr_price_subs_val = val;

            curr_price_subs = Shopify.formatMoney(val, "{{amount}}");
          }
        });
        jQuery.each(subs_Product_d.variant_to_price, function (key, val) {
          if (key == currentVariant) {
            curr_price_val = val;
            curr_price = Shopify.formatMoney(val, "{{amount}}");
          }
        });
        let difference = curr_price_val - curr_price_subs_val;
        difference = Shopify.formatMoney(difference, "{{amount}}");
        jQuery(".subscription-savings").html(
          "Save $" + difference + " per shipment"
        );
        if (jQuery(".rc_radio__autodeliver").is(":checked")) {
          console.log(curr_price_subs);
          if (curr_price_subs != 0) {
            jQuery("#rc_price_autodeliver").html("$ " + curr_price_subs);
            this.setAvailableDisable();
          } else {
            jQuery("#rc_price_autodeliver").html("$ 0.00");
            this.setUnavailableDisable();
          }
          if (curr_price != 0) {
            jQuery("#rc_price_onetime").html("$ " + curr_price);
          }
        }

        if (jQuery(".rc_radio__onetime").is(":checked")) {
          if (curr_price_subs == 0) {
            jQuery("#rc_price_autodeliver").html("$ 0.00");
          }
        }
        jQuery(".js-main-hiddenInput").val(currentVariant);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"]');
    //inventory
    const inventoryNote = document.querySelector(".inventoryNote");
    //console.log(variantStock[this.currentVariant.id])
    if (variantStock[this.currentVariant]) {
      const inventoryHtml = `${variantStock[this.currentVariant.id][0]}`;
    }
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");

      if (text) addButtonText.textContent = text;
      //inventory
      inventoryNote.innerHTML = "";
      //show disable radio select
      document.querySelectorAll(".sr-only").forEach((item) => {
        if (item.checked === true) {
          item.classList.add("disabled");
        }
      });
      //document.querySelector('.quantity__input').removeAttribute('max')
    } else {
      addButton.removeAttribute("disabled");
      //remove disable radio select
      document.querySelectorAll(".sr-only").forEach((item) => {
        item.classList.remove("disabled");
      });
      // addButtonText.textContent = window.variantStrings.addToCart
      document.querySelector(".ajax-add-notice").classList.add("hidden");
      //inventory
      if (
        variantStock[this.currentVariant.id][0] > 0 &&
        variantStock[this.currentVariant.id][1] === "deny" &&
        variantStock[this.currentVariant.id][2] === "shopify"
      ) {
        inventoryNote.textContent = inventoryHtml;
        //document.querySelector('.quantity__input').setAttribute('max',inventoryHtml)
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  setAvailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"]');

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.addToCart;
  }

  setUnavailableDisable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    addButton.setAttribute("disabled", "disabled");
  }

  setAvailableDisable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"]');

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.addToCart;
    addButton.removeAttribute("disabled");
  }

  getVariantData() {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    this.variantData =
      this.variantData ||
      JSON.parse(productForm.querySelector("#selectjson").textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}
customElements.define("variant-radios", VariantRadios);

//Load Product Page and check current varian product image
function updateId() {
  //Radio
  if (document.querySelectorAll("variant-radios").length === 1) {
    document.querySelectorAll(".sr-only").forEach((variant) => {
      if (variant.checked) {
        variant.parentNode.closest(
          ".option-grid"
        ).previousElementSibling.lastChild.textContent = variant.value;
      }
      variant.addEventListener("click", function () {
        this.parentNode.closest(
          ".option-grid"
        ).previousElementSibling.lastChild.textContent =
          this.parentNode.dataset.name;
      });
    });
  }
  //Select
  if (document.querySelectorAll("variant-selects").length === 1) {
    document.querySelectorAll(".option-variant").forEach((variant) => {
      if (variant.selected) {
        //variant.parentNode.closest(".select").previousElementSibling.lastChild.previousSibling.textContent = variant.value
      }
    });
    document.querySelectorAll(".select__select").forEach((variant) => {
      variant.addEventListener("change", function () {
        //variant.parentNode.closest(".select").previousElementSibling.lastChild.previousSibling.textContent = this.value
      });
    });
  }
  //Radio
  if (document.querySelectorAll("#radiojson").length === 1) {
    this.variantData =
      this.variantData ||
      JSON.parse(document.querySelector("#radiojson").textContent);
    var varData =
      this.variantData ||
      JSON.parse(document.querySelector("#radiojson").textContent);

    this.currentVariant = this.variantData.find((variant, index) => {
      if (
        variant.id == document.querySelector(".sr-only[data-id]").dataset.id &&
        variant.featured_image != null
      ) {
        //load page choose current image slide
        setTimeout(function () {
          productSliderupdate(variant.featured_media.id);
        }, 300);
      }
    });
    let variable = this.variantData.find(
      (variant, index) => index === 0 && variant.available === false
    );
    if (!document.querySelector(".sr-only[data-id]").dataset.id && variable) {
      this.variantData.find((variant, index) => {
        if (variant.available === true && index === 1) {
          productSliderupdate(variant.featured_media.id);
        }
      });
    }
    //Not avaliable radio
    this.variantData = this.variantData.find((variant) => {
      if (variant.available === false) {
        document.querySelectorAll(".sr-only").forEach((item) => {
          if (variant.title === item.value) {
            item.classList.add("novaliable");
          }
        });
      }
    });
  }
  //Select
  if (document.querySelectorAll("#selectjson").length === 1) {
    this.variantData =
      this.variantData ||
      JSON.parse(document.querySelector("#selectjson").textContent);

    this.currentVariant = this.variantData.find((variant, index) => {
      if (
        variant.id ==
          document.querySelector(".option-variant[data-id]").dataset.id &&
        variant.featured_image != null
      ) {
        //load page choose current image slide
        setTimeout(function () {
          productSliderupdate(variant.featured_media.id);
        }, 300);
      }
    });
    let variable = this.variantData.find(
      (variant, index) => index === 0 && variant.available === false
    );

    if (
      !document.querySelector(".option-variant[data-id]").dataset.id &&
      variable
    ) {
      this.variantData.find((variant, index) => {
        if (variant.available === true && index === 1) {
          productSliderupdate(variant.featured_media.id);
        }
      });
    }

    this.variantData = this.variantData.find((variant) => {
      if (variant.available === false) {
        document.querySelectorAll(".option-variant").forEach((item) => {
          if (variant.title === item.value) {
            item.classList.add("novaliable");
          }
        });
      }
    });
  }

  //Chek if is current variant avaliable
  if (document.querySelectorAll("input.sr-only").length > 0) {
    if (document.querySelector(".product-form__submit").disabled === true) {
      //show disable radio select
      document.querySelectorAll(".sr-only").forEach((item) => {
        if (item.checked === true) {
          item.classList.add("disabled");
        }
      });
    }
  }
}
updateId();

//Produc Slider Update
function productSliderupdate(variantImageId) {
  //Swatcher chnage slide
  if (document.querySelectorAll(".gallery-top .swiper-slide").length > 0) {
    const hittedIndex = document.querySelector(
      '.imageslide-item[data-thumbid="' + variantImageId + '"]'
    ).dataset.index;

    document.querySelectorAll(".gallery-top").forEach((item) => {
      let sliderImages = new Swiper(item, {
        direction: item.dataset.direction,
        spaceBetween: 0,
        allowTouchMove: false,
        scrollbar: {
          el: ".swiper-scrollbar",
        },
        breakpoints: {
          0: {
            direction: "horizontal",
            allowTouchMove: true,
            spaceBetween: 0,
          },
          768: {
            direction: item.dataset.direction,
          },
        },
      });
      sliderImages.update();
      sliderImages.slideTo(hittedIndex, 0, false);
    });
  }
}
//Preview product card slider
function previewCardSlider() {
  if ($(".preview-card-slider").length > 0) {
    document.querySelectorAll(".preview-card-slider").forEach((item) => {
      const sliderProductCard = new Swiper(item, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 1000,
        grabCursor: true,
        navigation: {
          nextEl: item.firstElementChild.nextElementSibling.firstElementChild,
          prevEl:
            item.firstElementChild.nextElementSibling.firstElementChild
              .nextElementSibling,
        },
        pagination: {
          el: item.firstElementChild.nextElementSibling.lastElementChild,
          clickable: true,
        },
      });
    });
  }
}
previewCardSlider();
//siblings get
const getSiblings = function (elem) {
  // Setup siblings array and get the first sibling
  let siblings = [];
  let sibling = elem.parentNode.firstChild;
  // Loop through each sibling and push to the array
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== elem) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }
  return siblings;
};

//Chnage image Card product preview
function chnageImageCardProdactPreview() {
  if (document.querySelectorAll(".preview-card").length > 0) {
    document.querySelectorAll(".preview-card").forEach((card) => {
      if (
        card.dataset.imagechnage != "false" ||
        card.dataset.updateslide != "false"
      ) {
        if (
          card.querySelectorAll(".preview-card .thumbnail-swatch").length > 0
        ) {
          card.querySelectorAll(".card-color-swatch").forEach((item) => {
            item.addEventListener("click", chnageMouseover);

            //mouseover
            function chnageMouseover(event) {
              event.preventDefault();

              //chnage image withous slider
              if (
                card.parentNode.parentNode.parentNode.parentNode.querySelector(
                  ".preview-card"
                ).dataset.imagechnage != "false"
              ) {
                //event.target.parentNode.parentNode.previousElementSibling.firstElementChild.style.backgroundImage = 'url('+event.target.dataset.image+')';
                event.target.parentNode.parentNode.previousElementSibling.firstElementChild.firstElementChild.nextElementSibling.setAttribute(
                  "srcset",
                  event.target.dataset.imagerate
                );
                event.target.parentNode.parentNode.previousElementSibling.firstElementChild.setAttribute(
                  "href",
                  event.target.dataset.url
                );
                event.target.parentNode.parentNode.firstElementChild.setAttribute(
                  "href",
                  event.target.dataset.url
                );
              }

              //chnage image in slider
              if (
                item.parentNode.parentNode.parentNode.parentNode.querySelector(
                  ".preview-card"
                ).dataset.updateslide != "false" &&
                card.parentNode.parentNode.parentNode.parentNode.querySelector(
                  ".preview-card-slider"
                )
              ) {
                event.target.parentNode.parentNode.firstElementChild.setAttribute(
                  "href",
                  event.target.dataset.url
                );
                Array.from(
                  event.target.parentNode.parentNode.previousElementSibling
                    .firstElementChild.firstElementChild.children
                ).find((slide) => {
                  if (slide.dataset.id == event.target.dataset.mediaid) {
                    const speccliseUpdate = new Swiper(
                      event.target.parentNode.parentNode.previousElementSibling.firstElementChild,
                      {
                        navigation: {
                          nextEl:
                            event.target.parentNode.parentNode
                              .previousElementSibling.firstElementChild
                              .firstElementChild.nextElementSibling
                              .firstElementChild,
                          prevEl:
                            event.target.parentNode.parentNode
                              .previousElementSibling.firstElementChild
                              .firstElementChild.nextElementSibling
                              .firstElementChild.nextElementSibling,
                        },
                        pagination: {
                          el: event.target.parentNode.parentNode
                            .previousElementSibling.firstElementChild
                            .firstElementChild.nextElementSibling
                            .lastElementChild,
                          clickable: true,
                        },
                      }
                    );
                    speccliseUpdate.slideTo(slide.dataset.index, 600, false);
                    speccliseUpdate.update();
                  }
                });
              }

              let getSiblingsitem = getSiblings(event.target);
              getSiblingsitem.forEach((siblings) => {
                //siblings item remove hovered
                siblings.classList.remove("hovered");
              });
              //add current item hovered class
              event.target.classList.add("hovered");
            } //end hover function
          }); //end foreach
        } //end check color swatcher has
      }
    }); //for each status false
  }
}
chnageImageCardProdactPreview();

//Ajax pagination collectionpage

function ajaxPagination() {
  if (document.querySelectorAll("#moreload").length > 0) {
    let counter = 2;
    let pages = document.querySelector("#moreload").dataset.pagemax;
    let maxCount = Number(pages) + 1;
    if (document.querySelector(".autoload")) {
      let observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting == true) {
            //check url filter
            let getUrl;
            if (!location.search) {
              getUrl = location.href + "?page=" + counter;
            } else {
              getUrl = location.href + "&page=" + counter;
            }

            //Add disabled button
            document.querySelector("#moreload").disabled = true;
            //Remove class new load product card
            document.querySelectorAll(".grid__item").forEach((item) => {
              item.classList.remove("loaded-product");
            });

            console.log(getUrl);

            setTimeout(function () {
              $.ajax({
                url: getUrl,
                type: "GET",
                beforeSend: function () {
                  //add disable button
                },
                complete: function () {
                  //Preview product card slider -- global js
                  previewCardSlider();
                  // chnage image card when click color swatcher -- global.js
                  chnageImageCardProdactPreview();
                  //shop collection coun number products
                  countShowingProduct();
                  //size card
                  chooseSizeCard();
                  //button load
                  addtoCardPreview();
                },
                success: function (data) {
                  counter++;

                  let html_div = document.createElement("div");
                  html_div.innerHTML = data;

                  //add class new load product card
                  html_div.querySelectorAll(".grid__item").forEach((item) => {
                    item.classList.add("loaded-product");
                  });

                  html_div
                    .querySelectorAll(".product-grid-dann")
                    .forEach((item) => {
                      let loadedData = item.innerHTML;
                      document.querySelector(".product-grid-last").innerHTML +=
                        loadedData;
                    });

                  //console.log(loadedData);
                  // add new product

                  //remove disable button
                  document.querySelector("#moreload").disabled = false;
                  // remove button
                  if (counter == maxCount) {
                    document.querySelector("#moreload").parentNode.remove();
                  }
                },
              }); //end ajax request
            }, 1000);
          }
        });
      });

      let el = document.querySelector("#moreload");

      observer.observe(el);
    }

    document.querySelector("#moreload").addEventListener("click", function (e) {
      e.preventDefault();

      //check url filter
      let getUrl;
      if (!location.search) {
        getUrl = location.href + "?page=" + counter;
      } else {
        getUrl = location.href + "&page=" + counter;
      }

      //Add disabled button
      document.querySelector("#moreload").disabled = true;
      //Remove class new load product card
      document.querySelectorAll(".grid__item").forEach((item) => {
        item.classList.remove("loaded-product");
      });

      setTimeout(function () {
        $.ajax({
          url: getUrl,
          type: "GET",
          beforeSend: function () {
            //add disable button
          },
          complete: function () {
            //Preview product card slider -- global js
            previewCardSlider();
            // chnage image card when click color swatcher -- global.js
            chnageImageCardProdactPreview();
            //shop collection coun number products
            countShowingProduct();
            //size card
            chooseSizeCard();
            //button load
            addtoCardPreview();
          },
          success: function (data) {
            counter++;

            let html_div = document.createElement("div");
            html_div.innerHTML = data;

            //add class new load product card
            html_div.querySelectorAll(".grid__item").forEach((item) => {
              item.classList.add("loaded-product");
            });

            let loadedData = html_div.querySelector("#product-grid").innerHTML;
            // add new product
            document.querySelector("#product-grid").innerHTML += loadedData;

            //remove disable button
            document.querySelector("#moreload").disabled = false;
            // remove button
            if (counter == maxCount) {
              document.querySelector("#moreload").parentNode.remove();
            }
          },
        }); //end ajax request
      }, 1000); //end setTimeout
    }); //end click
  }
}
ajaxPagination();

//Count collection product showing
function countShowingProduct() {
  if (document.querySelector(".js-showing-product")) {
    document.querySelector(".js-showing-product").innerHTML =
      document.querySelectorAll(".grid__item").length;
  }
}
countShowingProduct();

//Select size preview card
function chooseSizeCard() {
  if (document.querySelectorAll(".js-show-select").length > 0) {
    document.querySelectorAll(".js-show-select").forEach((item) => {
      item.addEventListener("click", function () {
        console.log("Opening modal...");
        item.previousElementSibling.classList.add("open");
        item.previousElementSibling.lastElementChild.classList.add("open");
        item.parentNode.parentNode.parentNode.classList.add("open");
        item.parentNode.classList.add("open");
      });
    });

    document.querySelectorAll(".js-close-select").forEach((item) => {
      item.addEventListener("click", function () {
        console.log("Closing modal...");
        item.parentNode.classList.remove("open");
        item.parentNode.parentNode.parentNode.parentNode.classList.remove(
          "open"
        );
        item.parentNode.parentNode.classList.remove("open");
        item.nextElementSibling.nextElementSibling.classList.remove("open");
        item.parentNode.nextElementSibling.classList.remove("hide-btn");
      });
    });

    document.querySelectorAll(".js-select-varian-ls").forEach((item) => {
      item.addEventListener("click", function () {
        item.parentNode.classList.add("loading");
        setTimeout(function () {
          item.parentNode.nextElementSibling.classList.add("hide-btn");
          item.parentNode.classList.remove("loading");
        }, 1500);
      });
    });
  } //end if has js-show-select button

  // Change size attribute in select for mobile - fix bug
  if (window.innerWidth < 576) {
    document
      .querySelectorAll(".preview-card .card-select-variant")
      .forEach((item) => {
        item.setAttribute("size", "1");
      });
  }
}
chooseSizeCard();

function addtoCardPreview() {
  document
    .querySelectorAll(".card-send-btn.product-form__submit")
    .forEach((item) => {
      item.addEventListener("click", function () {
        item.classList.add("adding");
        item.setAttribute("disabled", true);
        setTimeout(function () {
          item.classList.remove("adding");
          item.removeAttribute("disabled", false);
          item.parentNode.classList.remove("open");
          item.parentNode.parentNode.parentNode.classList.remove("open");
          item.parentNode.firstElementChild.classList.remove("open");
          //item.parentNode.firstElementChild.lastElementChild.classList.remove('open');
          item.previousElementSibling.classList.remove("hide-btn");
        }, 3000);
      });
    });
}
addtoCardPreview();

// CartPerformance class - Required by Dawn's cart system
class CartPerformance {
  static #metric_prefix = "cart-performance";

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp,
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(metricName, `${metricName}:start`, `${metricName}:end`);
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(metricName, startMarker.name, `${metricName}:end`);
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(metricName, `${metricName}:start`, `${metricName}:end`);
  }
}

// global fix for snippets/buy-buttons-supp-collagen-powder.liquid
(() => {
  const MAIN_PROPERTY = '_col-pow-sp';
  const GIFT_PARENT_PROPERTY = '_col-pow-sp-parent';
  const EVENT_SOURCE = 'collagen-gwp-sync';
  let syncInProgress = false;

  async function removeOrphanedGifts(cart) {
    if (syncInProgress || !cart || !Array.isArray(cart.items)) return;

    const parentVariantIds = new Set(
      cart.items
        .filter((item) => item.properties && item.properties[MAIN_PROPERTY])
        .map((item) => String(item.variant_id))
    );

    const orphanedGifts = cart.items.filter((item) => {
      const parentVariantId = item.properties && item.properties[GIFT_PARENT_PROPERTY];
      return parentVariantId && !parentVariantIds.has(String(parentVariantId));
    });

    if (orphanedGifts.length === 0) return;

    syncInProgress = true;

    try {
      const updates = {};
      orphanedGifts.forEach((item) => {
        updates[item.key] = 0;
      });

      const response = await fetch(window.routes.cart_update_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ updates }),
      });

      if (!response.ok) throw new Error('Unable to remove orphaned collagen gift');

      const updatedCart = await response.json();
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        await publish(PUB_SUB_EVENTS.cartUpdate, {
          source: EVENT_SOURCE,
          cartData: updatedCart,
        });
      }
    } catch (error) {
      console.error('Collagen GWP cleanup error:', error);
    } finally {
      syncInProgress = false;
    }
  }

  async function checkCart() {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
        headers: { Accept: 'application/json' },
      });
      if (response.ok) await removeOrphanedGifts(await response.json());
    } catch (error) {
      console.error('Collagen GWP cart check error:', error);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === EVENT_SOURCE) return;
        return removeOrphanedGifts(event.cartData);
      });
    }

    checkCart();
  });
})();